<template>
  <div class="sp-template">
    <!-- 从提成页面复制 commission.vue -->
    <div class="h-title">应收预警</div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">

        <el-form :inline="true" :model="conditions" class="header-search__form" size="small" label-width="90px">

          <el-row>
            

            <!-- <el-form-item label="开始时间" label-width="100px">
              <el-date-picker v-model.lazy="conditions.startDate" type="date" value-format="yyyy-MM-dd"
                placeholder="开始日期"></el-date-picker>
            </el-form-item>
            <el-form-item label="结束时间" label-width="100px">
              <el-date-picker v-model.lazy="conditions.endDate" type="date" value-format="yyyy-MM-dd"
                placeholder="结束日期"></el-date-picker>
            </el-form-item> -->

          <!-- </el-row>
          <el-row> -->

            <el-form-item label="客户">
              <el-select v-model="conditions.orgOwner" filterable clearable placeholder="选择客户">
                <el-option v-for="(d, i) in customers" :key="i" :label="d.name" :value="d.id"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="问题件类型" >
              <el-select v-model.lazy="conditions.type" filterable clearable >
                <el-option v-for="(d, i) in typelist" :key="i" :label="d.name" :value="d.id"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="备注类型">
              <el-select v-model.lazy="conditions.remarksType" filterable clearable >
                <el-option v-for="(d, i) in remarksTypeList" :key="i" :label="d.name" :value="d.id"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="创建时间">
              <el-date-picker
              v-model.lazy="daterange1"
                value-format="yyyy-MM-dd"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"                
                :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item>

          </el-row>
          <el-row>
            <el-form-item>
              <div class="search-form__buttons">
                <el-button type="primary" size="small" @click="searchTask">搜 索</el-button>
              </div>
            </el-form-item>
          </el-row>

        </el-form>
      </div>
      <div class="table-operate__buttons">
        <el-tabs v-model="conditions.status" @tab-click="searchTask">
          <el-tab-pane label="待财务处理" name="0"></el-tab-pane>
          <el-tab-pane label="已处理" name="1"></el-tab-pane>
        </el-tabs>
        <div class="button-groups">
          <el-button size="small" @click="popEditBatch()" v-if="in_configs(110301)" v-show="conditions.status==0">编辑</el-button>

          <el-button size="small" @click="exportAll()">导出</el-button>
        </div>
      </div>
      <el-table :data="tableData" stripe border  style="width: 100%"  @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>

        <!-- <el-table-column prop="id" label="id"></el-table-column> -->
        <el-table-column label="客户">
          <template slot-scope="scope">
            <!-- <a href="#" class="check" @click.prevent="doCopy(customerMaps[scope.row.orgOwner])">{{customerMaps[scope.row.orgOwner]}}</a> -->
            <a :href="'/customer/customerlist?orgOwner='+scope.row.orgOwner" class="check" target="_blank">{{customerMaps[scope.row.orgOwner]}}</a>
          </template>
        </el-table-column>
        <el-table-column label="类型">
          <template slot-scope="scope">
            {{typemaps[scope.row.type]}}
          </template>
        </el-table-column>
        
        <el-table-column prop="createdAt" label="创建时间"></el-table-column>
        <el-table-column prop="updatedAt" label="最后编辑时间"></el-table-column>
        <el-table-column prop="remarks" label="备注"></el-table-column>

        <el-table-column label="操作" v-if="conditions.status==0 ">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="popEdit(scope.row)"  v-if="in_configs(110301)" > 编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page.sync="conditions.currentPage" :page-sizes="[10, 50, 100, 500, 2000, 10000]" :page-size.sync="conditions.pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </el-card>

  
    <el-dialog title="编辑" :visible.sync="dialogEditVisible" width="400px" :close-on-click-modal="false" >
      <el-form size="small" label-width="100px">

        <el-form-item label="状态">
          <el-select v-model.lazy="editData.status" filterable clearable >
            <el-option v-for="(d, i) in statuslist" :key="i" :label="d.name" :value="d.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="备注类型">
          <el-select v-model.lazy="editData.remarksType" filterable clearable >
            <el-option v-for="(d, i) in remarksTypeList" :key="i" :label="d.name" :value="d.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="备注" v-if="editData.remarksType==6">
          <el-input type="textarea" v-model.lazy="editData.remarks"></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogEditVisible=false">取 消</el-button>
        <el-button size="small" type="primary" @click="editSubmit()">确 定</el-button>
      </div>
    </el-dialog>

  </div>




</template>

<script>
  import { base64ToUint8Array, dateFormat, pickerOptions } from '@/util/formUtil'
  import { mapState, mapMutations } from "vuex";
  export default {
    data() {
      return {
        daterange1: "",
        pickerOptions: pickerOptions,
        remarksTypeList: [{"name":"申请开船付","id":0},{"name":"申请到港付","id":1},{"name":"申请签收付","id":2},{"name":"对冲","id":3},{"name":"拒付","id":4},{"name":"习惯性拖款","id":5},{"name":"其它","id":6}],
        remarksTypeMap: {"0":"申请开船付","1":"申请到港付","2":"申请签收付","3":"对冲","4":"拒付","5":"习惯性拖款","6":"其它"},

        typelist: [{"name":"超月结（30天内）","id":1},{"name":"超半月结（5天内）","id":2},{"name":"超周结（5天内）","id":3},{"name":"超日结（从测量当天开始算，第3天）","id":4}],
        typemaps: {"1":"超月结","2":"超半月结","3":"超周结","4":"超日结"},
        statuslist: [{"id":0,"name": "待财务处理"},{"id":1,"name": "已处理"}],
        customers: [],
        customerMaps: {},

        sumbitForm: {
          categoryId: "",
          kindId: "",
          supplierId: ""
        },
        dialogCheckVisible: false,
        tableData: [],
        batchOrderIds: [],
        multipleSelection: [],

        conditions: {
          which: 3,
          orderIdText: '',
          startDate: "",
          endDate: "",
          orgOwner: "",
          status: 0,
          type: "",
          currentPage: 1,
          pageSize: 10
        },

        dialogEditVisible: false,
        editData: {
          "which": 3,
          "ids": [],
          "status": 0,
          remarksType: '',
          "remarks": ""
        },
        total: 0
      };
    },
    components: {},
    created() {
      setTimeout(() => {

        let _this = this;
        let urlArray = [
          this.findAllCustomerName(),
        ];

        this.$axios.all(urlArray).then(
          this.$axios.spread(function (customerData) {
            _this.initCustomerData(customerData);

            _this.query();
          })
        );



      }, 1000);
    },
    methods: {
      doCopy: function (text) {
        let _this = this
        this.$copyText(text).then(function (e) {
          _this.$message.success(text + '已复制')
          // console.log(e)
        }, function (e) {
          console.log(e)
        })
      },
      ...mapMutations([
        "setManualTrackingNumbers",
        "setOrderListTable",
        "setOrderListConditions",
        "setOrderListSearchMore"
      ]),
      formatRefNumber(refNumber) {
        let arr = refNumber;
        arr.forEach((item, index) => {
          if (item === " " || item === ",") {
            arr.splice(index, 1);
          }
        });
        return arr;
      },
     
      //查询客户
      findAllCustomerName() {
        return this.$request1.get(
          '/customerAll',
          {
            withCredentials: true
          }
        );
      },
      
      initCustomerData(data) {
        let _this = this;
        if (data.data.success) {
          _this.customers = data.data.data;
          if (_this.customers.length > 0) {
            _this.customers.forEach(c => {
              _this.customerMaps[c.id] = c.name;
            });
          }
        }
      },
      searchTask() {
        this.conditions.currentPage = 1;
        this.query();
      },
      query() {
        let _this = this;

        this.conditions.orderIds = [];
        if (this.conditions.orderIdText) {
          this.conditions.orderIds = this.conditions.orderIdText.split(/\n+/gim).map(a => a.trim()).filter(a => a);
        }

        this.conditions.startDate = this.daterange1 && this.daterange1.length==2 ? this.daterange1[0] : ""
        this.conditions.endDate = this.daterange1 && this.daterange1.length==2 ? this.daterange1[1] : ""
        this.conditions.export = 0

        this.$request1({
          method: 'post',
          url: '/alarm/query',
          data: _this.conditions,
          withCredentials: true,
          header: {
            'Content-Type': 'application/json'
          }
        })
          .then(response => {
            if (response.data.success) {
              this.tableData = response.data.data.list;
              this.total = response.data.total;
              
            } else {
              this.$message.error(response.data.message);
            }
          })
          .catch(error => {
            console.log(error);
          });
      },
      // 批量编辑弹框
      popEditBatch() {
        let _this = this
        let t = '编辑'
        // console.log(this.multipleSelection.length);
        if (this.multipleSelection.length == 0) {
          this.$message.error(`请勾选要${t}的数据`);
          return;
        }
        this.dialogEditVisible = true;
        this.editData.status = null
        this.editData.remarks = ""
        this.editData.remarksType = ""
        this.editData.ids = this.multipleSelection.map(a => a.id).filter(a => a)
      },

      popEdit(row) {
        this.dialogEditVisible = true;

        this.editData.ids = [row.id]
        this.editData.status = ""
        this.editData.remarks = row.remarks
        this.editData.remarksType = row.remarksType

      },
      editSubmit() {
        let _this = this;

        // 非其他
        if(this.editData.remarksType && this.editData.remarksType!='6'){
          this.editData.remarks = this.remarksTypeMap[this.editData.remarksType]
        }

        this.$request1
          .post(
            '/alarm/update',
            _this.editData,
            {
              withCredentials: true,
              headers: {
                "content-type": "application/json"
              }
            }
          )
          .then(function (response) {
            if (response.data.success) {
              _this.$message.success("提交成功");
              _this.dialogEditVisible = false
              _this.query();

            } else {
              _this.$message.error(response.data.message);
            }
          });

      },
      exportAll() {
        let _this = this;

        // var url = tmsSpringUrl + '/alarm/query';

        // var form = document.createElement("form");
        // form.method = "post";
        // form.action = url;
        // form.target = "_blank";
        // document.body.appendChild(form);

        this.conditions.startDate = this.daterange1 && this.daterange1.length==2 ? this.daterange1[0] : ""
        this.conditions.endDate = this.daterange1 && this.daterange1.length==2 ? this.daterange1[1] : ""
        this.conditions.export = 1

        this.$request1({
          url: '/alarm/query',
          method: 'post',
          data: this.conditions
        }).then(res => {
          if(res.data.success && res.data.data!=null && res.data.data.length>0){
            this.conditions.export = 0
            const link = document.createElement('a')
            let array = base64ToUint8Array(res.data.data)
            let blob = new Blob([array])
            link.style.display = 'none'
            link.href = URL.createObjectURL(blob)
            let timestr = dateFormat(new Date(), 'yyyyMMddHHmmss')
            link.setAttribute('download', `alarm_${timestr}.xlsx`)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          }else{
            this.$message.error('没有数据');
          }          
        })


      //   Object.keys(this.conditions).forEach(key => {
      //     var input1 = document.createElement("input");
      //     input1.type = "hidden";
      //     input1.name = key;
      //     input1.value = this.conditions[key];
      //     form.appendChild(input1);
      //   })


      //   var input2 = document.createElement("input");
      // input2.type = "hidden";
      // input2.name = "token";
      // input2.value = this.$getToken()
      // form.appendChild(input2);
      
      //   form.submit();

      },
      //多选按钮
      handleSelectionChange(val) {
        // console.log(">>>val=", val);
        this.multipleSelection = val;
      },
      //分页
      handleSizeChange(val) {
        this.conditions.currentPage = 1;
        this.conditions.pageSize = val;
        this.query();
      },
      handleCurrentChange(val) {
        this.conditions.currentPage = val;
        this.query();
      },
      dateFormat(date, fmt) {
        var o = {
          "M+": date.getMonth() + 1, //月份
          "d+": date.getDate(), //日
          "h+": date.getHours() % 12 == 0 ? 12 : date.getHours() % 12, //小时
          "H+": date.getHours(), //小时
          "m+": date.getMinutes(), //分
          "s+": date.getSeconds(), //秒
          "q+": Math.floor((date.getMonth() + 3) / 3), //季度
          S: date.getMilliseconds() //毫秒
        };
        var week = {
          "0": "/u65e5",
          "1": "/u4e00",
          "2": "/u4e8c",
          "3": "/u4e09",
          "4": "/u56db",
          "5": "/u4e94",
          "6": "/u516d"
        };
        if (/(y+)/.test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            (date.getFullYear() + "").substr(4 - RegExp.$1.length)
          );
        }
        if (/(E+)/.test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            (RegExp.$1.length > 1
              ? RegExp.$1.length > 2
                ? "/u661f/u671f"
                : "/u5468"
              : "") + week[date.getDay() + ""]
          );
        }
        for (var k in o) {
          if (new RegExp("(" + k + ")").test(fmt)) {
            fmt = fmt.replace(
              RegExp.$1,
              RegExp.$1.length == 1
                ? o[k]
                : ("00" + o[k]).substr(("" + o[k]).length)
            );
          }
        }
        return fmt;
      }
    }
  };
</script>

<style>
  .el-message-box__message p {
    margin: 0;
    line-height: 24px;
    white-space: pre-wrap !important;
  }
</style>


// WEBPACK FOOTER //
// src/views/alarm/alarm_amount.vue